import { Component, Input, OnInit } from '@angular/core';
import { LanguageService, StorageService, TempKey } from '@services/public';
import { WWYDAction, WWYDData, WWYD_PAGE } from '../common';
import { SelectListOption } from '@components';
import { ReplaySubject } from 'rxjs';
import { ExposedPromise, JClone } from 'jakapa-utilities-lite';

const PAGE_PATH: string = 'skillBuilders.wwyd.pages.benefits';

@Component({
	selector: 'app-member-skill-builder-wwyd-benefits',
	templateUrl: './benefits.component.html',
	styleUrls: ['./benefits.component.scss'],
})
export class MemberSkillBuilderWwydBenefitsComponent implements OnInit {
	@Input() data: WWYDData;
	submitted: boolean = false;
	private _options: Array<SelectListOption> = [];
	private _optionsLoaded: ExposedPromise<void> = new ExposedPromise<void>();

	// Page langauge.
	page: { [key: string]: string } = {
		next: '',
	};

	constructor(
		private _languageSvc: LanguageService,
		private _storageSvc: StorageService,
	) {}

	ngOnInit(): void {
		// Get page language.
		this._languageSvc.get([PAGE_PATH]).then((value) => {
			if (typeof value[PAGE_PATH] !== 'object' || value[PAGE_PATH] === null)
				return;
			this.page = value[PAGE_PATH];
			for (const key in this.page)
				this._languageSvc
					.template(this.page[key])
					.then((value) => (this.page[key] = value));
		});

		// Get options list.
		const path: string = 'skillBuilders.wwyd.benefits';
		this._languageSvc.get([path]).then((value) => {
			if (typeof value[path] === 'object' && value[path] !== null)
				this._options = Object.values(value[path]);
			this._optionsLoaded.resolve();
		});
	}

	getOptions(action: WWYDAction): ReplaySubject<Array<SelectListOption>> {
		const options = new ReplaySubject<Array<SelectListOption>>(1);
		this._optionsLoaded.then(() => {
			options.next(
				JClone(this._options).map((option) => {
					if (option.value === action.beneficial) option.selected = true;
					return option;
				}),
			);
		});
		return options;
	}

	onChange(action: WWYDAction, option: SelectListOption) {
		action.beneficial = option.value;
	}

	nextOnClick(): void {
		this.submitted = true;
		for (const action of this.data.actions) if (!action.beneficial) return;
		this._storageSvc.setTempStorage(TempKey.WWYD, {
			...this.data,
			page: WWYD_PAGE.CHOOSE_ACTION,
		});
	}
}
